import { render, staticRenderFns } from "./ComponentEditorBtnGroup.vue?vue&type=template&id=1a98aa72&scoped=true"
import script from "./ComponentEditorBtnGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentEditorBtnGroup.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ComponentEditorBtnGroup.vue?vue&type=style&index=0&id=1a98aa72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98aa72",
  null
  
)

export default component.exports